module.exports = __webpack_public_path__ + "media/offers_icons/budowlane-white-5bf43cff.svg";